var _defs, _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVisibilityOffOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "VisibilityOff",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_289",
    "data-name": "Rectangle 289",
    width: 22,
    height: 19.15,
    transform: "translate(0 0)",
    fill: "#333"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_30",
    "data-name": "Rectangle 30",
    width: 24,
    height: 24,
    fill: "#a7aeb0",
    opacity: 0
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1770",
    "data-name": "Groupe 1770",
    transform: "translate(1 2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1769",
    "data-name": "Groupe 1769",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_412",
    "data-name": "Trac\\xE9 412",
    d: "M11,3.55a9.77,9.77,0,0,1,8.82,5.5,9.647,9.647,0,0,1-2.41,3.12l1.41,1.41A11.8,11.8,0,0,0,22,9.05,11.834,11.834,0,0,0,7.36,2.12L9.01,3.77A10.108,10.108,0,0,1,11,3.55M9.93,4.69,12,6.76a2.5,2.5,0,0,1,1.28,1.28l2.07,2.07a4.679,4.679,0,0,0,.14-1.07A4.483,4.483,0,0,0,11,4.55a4.244,4.244,0,0,0-1.07.14M1.01,1.42,3.69,4.1A11.738,11.738,0,0,0,0,9.05a11.827,11.827,0,0,0,11,7.5,11.73,11.73,0,0,0,4.32-.82l3.42,3.42,1.41-1.41L2.42,0Zm7.5,7.5,2.61,2.61a.5.5,0,0,1-.12.02,2.5,2.5,0,0,1-2.5-2.5c0-.05.01-.08.01-.13m-3.4-3.4L6.86,7.27A4.6,4.6,0,0,0,6.5,9.05a4.505,4.505,0,0,0,6.27,4.14l.98.98a10.432,10.432,0,0,1-2.75.38,9.77,9.77,0,0,1-8.82-5.5A9.9,9.9,0,0,1,5.11,5.52",
    fill: "#959FB2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisibilityOffOutlined);
export default __webpack_public_path__ + "static/media/VisibilityOffOutlined.9d7ec69eed0e238089e821c6c891f59f.svg";
export { ForwardRef as ReactComponent };